import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { SEOContext } from "gatsby-plugin-wpgraphql-seo"

import StyleVariables from "./components/StyleVariables"
import Normalize from "./components/Normalize"
import FontFaces from "./components/FontFaces"
import Global from "./components/Global"

import Cookies from "../../components/global/Cookies.js"

import Aos from "aos"
import "aos/dist/aos.css"
import { Helmet } from "react-helmet"
import SiteLanguage from "../../helpers/siteLanguage.js"
import { prepareSchema } from "../../utils/seoUrls"
import { FooterContainer } from "../../components/global/common/containers"

const Layout = ({ children }) => {
  const {
    wp: { seo, structuredData },
  } = useStaticQuery(graphql`
    query SiteInfoQuery {
      wp {
        seo {
          contentTypes {
            post {
              title
              schemaType
              metaRobotsNoindex
              metaDesc
            }
            page {
              metaDesc
              metaRobotsNoindex
              schemaType
              title
            }
          }
          webmaster {
            googleVerify
            yandexVerify
            msVerify
            baiduVerify
          }
          schema {
            companyName
            personName
            companyOrPerson
            wordpressSiteName
            siteName
            inLanguage
            logo {
              sourceUrl
              mediaItemUrl
              altText
            }
          }
          social {
            facebook {
              url
              defaultImage {
                sourceUrl
                mediaItemUrl
              }
            }
            instagram {
              url
            }
            linkedIn {
              url
            }
            mySpace {
              url
            }
            pinterest {
              url
              metaTag
            }
            twitter {
              username
            }
            wikipedia {
              url
            }
            youTube {
              url
            }
          }
        }
        structuredData {
          en {
            structuredDataGlobal
          }
          pl {
            structuredDataGlobalPl
          }
        }
      }
    }
  `)

  let structuredDataGlobal

  if (SiteLanguage() === "en") {
    structuredDataGlobal = structuredData.en.structuredDataGlobal
  } else {
    structuredDataGlobal = structuredData.pl.structuredDataGlobalPl
  }

  // Page content goes into <main>; the CTA + footer block every template
  // ends with stays outside it, so the footer is the page's contentinfo.
  // FooterContainer is the only <footer> there: nested ones (Footer,
  // ButtonGroup) would be duplicate contentinfo landmarks.
  const content = React.Children.toArray(children)
  const footer = content.filter(child => child?.type === FooterContainer)
  const main = content.filter(child => child?.type !== FooterContainer)

  React.useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    })
  }, [])

  return (
    <SEOContext.Provider value={{ global: seo }}>
      <Helmet>
        <script type="application/ld+json">{prepareSchema(structuredDataGlobal)}</script>
      </Helmet>
      <FontFaces />
      <StyleVariables />
      <Normalize />
      <Global />
      <main>{main}</main>
      {footer}
      {/* After the content: it's fixed to the viewport, so its place in the
          HTML only matters to crawlers and screen readers, which should get
          the page's nav and h1 first. */}
      <Cookies />
    </SEOContext.Provider>
  )
}

export default Layout
